import { Box, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";

export const ScenarioBasedQuestion = ({
  question,
  questionId,
  studentAnswers,
  setStudentAnswers,
}) => {
  const [userAnswer, setUserAnswer] = useState(
    studentAnswers[questionId] || ""
  );

  useEffect(() => {
    // Update studentAnswers state when userAnswer changes
    setStudentAnswers((prev) => ({
      ...prev,
      [questionId]: userAnswer,
    }));
  }, [userAnswer, questionId, setStudentAnswers]);

  return (
    <Box>
      {/* Question Content */}
      <Typography align="left" variant="h6" mb={2}>
        {question.content}
      </Typography>

      {/* Multiline Answer Field */}
      <TextField
        label="Your Answer"
        value={userAnswer}
        onChange={(e) => setUserAnswer(e.target.value)}
        fullWidth
        multiline
        rows={8}
        placeholder="Type your detailed response here..."
        variant="outlined"
      />
    </Box>
  );
};
